document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".toggle-round").forEach(function (i) {
        i.addEventListener("click", function () {
            const i = this;
            i.querySelector("i").classList.toggle("rotate-180");
            i.nextElementSibling.classList.toggle("hidden");
        });
    });
});
